<div class="footer-menu__wrapper">
  <nav id="more-menu" class="more-menu">
    <div class="more-menu__backdrop" *ngIf="showMoreMenu"></div>
    <div class="more-menu__panel" [@SlideLeftRight]="slideDirection">
      <div class="more-menu__header">
        <div class="more-menu__close" (click)="toggleMoreMenu()">
          <svg-icon [type]="'cross'" [className]="'svg-more-menu__close'">  </svg-icon>
        </div> <div class="more-menu__username">
          {{userInfo.name }}
        </div>
      </div>
      <div class="more-menu__list">
        <a href="notifications.php" class="more-menu__item" [routerLink]="['/Notification/List']">
          <div class="more-menu__icon">
            <svg-icon [type]="'bell'" [className]="'svg-bell'">  </svg-icon>
            <div class="more-menu__badge" *ngIf="totalNotifications>0">{{totalNotifications}}</div>
          </div>
          Notifications
        </a>
        <a *ngIf="isCalenderAllowed" [routerLink]="['/Interviews/InterviewAgenda']" class="more-menu__item">
          <div class="more-menu__icon">
            <svg-icon [type]="'calender'" [className]="'svg-bell'">  </svg-icon>
          </div>
          My interviews
        </a> <a *ngIf="isMyNewStartersAllowed" href="new-starters.php" class="more-menu__item" [routerLink]="['/NewStarters/List']">
          <div class="more-menu__icon">
            <svg-icon [type]="'new_Starter'" [className]="'svg-bell'">  </svg-icon>
          </div>
          New starters
        </a>
        <a href="contacts.php" class="more-menu__item" [routerLink]="['/Contacts/List']">
          <div class="more-menu__icon">
            <svg-icon [type]="'contacts'" [className]="'svg-bell'">  </svg-icon>
          </div>
          Contacts
        </a>
        <a *ngIf="isTalentPoolAllowed" href="talent-pools.php" class="more-menu__item" [routerLink]="['/TalentPool/List']">
          <div class="more-menu__icon">
            <svg-icon [type]="'talent_pool'" [className]="'svg-bell'">  </svg-icon>
          </div>
          Talent pools
        </a>
      </div> <div class="more-menu__footer"><a [routerLink]="['/Login']" class="button button--highlight">Sign Out</a></div>
    </div>
  </nav>
  <ul class="footer-menu">
    <li class="footer-menu__item">
      <a [routerLink]="['/Home']" class="footer-menu__link " [routerLinkActive]="['footer-menu__link--active', '']">
        <svg-icon [type]="'home'" [className]="'svg-footer'">  </svg-icon>
        <span class="footer-menu__label">Home</span>
      </a>
    </li>
    <li class="footer-menu__item">
      <a [routerLink]="['/MyJobs/List']" class="footer-menu__link" [routerLinkActive]="['footer-menu__link--active', '']">
        <svg-icon [type]="'my_jobs'" [className]="'svg-footer'">  </svg-icon>
        <span class="footer-menu__label">My jobs</span>
      </a>
    </li>
    <li *ngIf="isSearchAllowed" class="footer-menu__item">
      <a [routerLink]="['/Search']" class="footer-menu__link" [routerLinkActive]="['footer-menu__link--active', '']">
        <svg-icon [type]="'search'" class="footer-menu__label" [className]="'svg-footer'">  </svg-icon>
        <span class="footer-menu__label">Search</span>
      </a>
    </li>
    <li class="footer-menu__item" (click)="toggleMoreMenu()">
      <div id="moreMenuTrigger" class="footer-menu__link" [routerLinkActive]="['footer-menu__link--active', '']">
        <span *ngIf="totalNotifications>0" class="footer-menu__notification"></span>
        <svg-icon [type]="'more'" [className]="'svg-footer'">  </svg-icon>
        <span class="footer-menu__label">More</span>
      </div>
    </li>
  </ul>
</div>
